<template>
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path id="Vector" d="M12.0249 5.44168L17.0832 10.5L12.0249 15.5583" stroke="black" stroke-width="1.27273" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path id="Vector_2" d="M2.9165 10.5H16.9415" stroke="black" stroke-width="1.27273" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>